// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"60f6ccf1","703":"f94f1a0a"}[chunkId] + ".chunk.js";
};